import {webRequest, webNoTokenRequest} from '../api'

// 上傳房東簽名檔
export function uploadSignature(data) {
    return webRequest({
        url:'/v1/oauth/management/landlord/uploadSignature',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        method:'post',
        data: data,
    })
}




// WEBPACK FOOTER //
// ./src/apis/company/landlorgMgt.js